import type { PlanInquiryAction, PlanInquiryStatus } from "./plan-inquiry.types";

/**
 * Máquina de estado do formulário de solicitação de plano — veio de
 * `apps/web/src/lib/plans/plan-inquiry-form-state.ts` quando o pedido de
 * proposta chegou ao app e ao desktop.
 */
/**
 * `reopen` sempre volta para `idle`, mesmo a partir de `sent` — reabrir o
 * modal depois de enviar precisa mostrar o formulário de novo, não a
 * confirmação da solicitação anterior.
 */
export function reducePlanInquiryStatus(
  status: PlanInquiryStatus,
  action: PlanInquiryAction,
): PlanInquiryStatus {
  switch (action.type) {
    case "submit":
      return "sending";
    case "resolved":
      return "sent";
    case "rejected":
      return "error";
    case "phone-required":
      return "needs-phone";
    case "reopen":
      return "idle";
    default:
      return status;
  }
}
